export const environment = {
  production: true,
  apiUrl: '/services/api/',
  reCaptchaKey: '6Lf9tEwUAAAAAG9PTBUeXMeEwnpJHWmgrtBzERWg'
};



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/environments/environment.ts